export default function starRatingWidget(editor) {
  editor.DomComponents.addType('eb-star-rating', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-star-rating'
    },
    model: {
      defaults: {
        name: 'Star Rating',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-star-rating', 'data-rating': '4', 'data-max': '5' },
        style: {
          'display': 'inline-flex',
          'gap': '4px',
          'padding': '10px',
          'font-size': '24px',
        },
        components: `
          <i class="fa fa-star" style="color:#f5a623;"></i>
          <i class="fa fa-star" style="color:#f5a623;"></i>
          <i class="fa fa-star" style="color:#f5a623;"></i>
          <i class="fa fa-star" style="color:#f5a623;"></i>
          <i class="fa fa-star-o" style="color:#ddd;"></i>
        `,
        traits: [
          { type: 'number', name: 'data-rating', label: 'Rating (0-5)', min: 0, max: 5, changeProp: true },
          { type: 'color', name: 'data-star-color', label: 'Star Color' },
        ],
      },
      init() {
        this.on('change:attributes:data-rating', this.updateStars)
      },
      updateStars() {
        const rating = parseInt(this.getAttributes()['data-rating'] || '4', 10)
        const max = parseInt(this.getAttributes()['data-max'] || '5', 10)
        const color = this.getAttributes()['data-star-color'] || '#f5a623'
        let html = ''
        for (let i = 0; i < max; i++) {
          if (i < rating) {
            html += `<i class="fa fa-star" style="color:${color};"></i>`
          } else {
            html += `<i class="fa fa-star-o" style="color:#ddd;"></i>`
          }
        }
        this.components(html)
      },
    },
  })

  editor.BlockManager.add('eb-star-rating', {
    label: 'Star Rating',
    category: 'Utility',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"/></svg>',
    content: { type: 'eb-star-rating' },
  })
}
